<template>
  <v-container fill-height fluid style="margin-top: -10px;">

    <h1 class="text-center" style="width: 100%;" v-if="!client_id">Neautorizovaný prístup</h1>

    <v-row class="text-center" justify="center" v-if="client_id && state == 'enterusername'">
        <v-col cols="12" style="max-width: 500px;">
            <div class="d-none d-sm-flex" style="height:64px;"></div>

            <v-row class="text-center" justify="center">
                <v-col cols="12" sm="12">
                    <p class="mb-1 heading1 text-center">{{ print('PARTNER.VOYO.SSO_WEB.RESET_PASSWORD_TITLE') }}</p>
                    <p class="mb-3 mt-3 heading1 text-center" style="border-bottom: 1px solid rgb(255,255,255,0.3); font-size:1px;">&nbsp;</p>
                    <p class="mb-1 heading2 text-center">{{ print('PARTNER.VOYO.SSO_WEB.RESET_PASSWORD_TEXT') }}</p>
                </v-col>
            </v-row>

            <v-row justify="center" v-if="error !== ''">
                <v-col cols="12" sm="12">
                    <p class="heading2 mb-0 mt-0" style="background-color: #FF00024D; color: white; border-radius: 5px; margin-top: 20px; padding: 15px 15px 15px 15px;">{{error}}</p>
                </v-col>
            </v-row>

            <v-row justify="center">
                <v-col cols="12" sm="12" class="pt-0 pb-5">
                    <v-text-field clearable outlined :placeholder="print('PARTNER.VOYO.SSO_WEB.USERNAME')" hide-details="auto" v-model="username" light background-color="white" color="#6C6C6C"
                    autocapitalize="off"></v-text-field>
                </v-col>
            </v-row>

            <v-row justify="center" style="text-align: left;"  class="pt-0 mt-0 mb-1">
                <v-col cols="12" sm="12" class="pt-0 m-0">
                    <p class="mt-1 mb-0 links"><router-link to="/howto">{{print('PARTNER.VOYO.SSO_WEB.LOGIN.HELP.USERNAME_BTN')}}</router-link></p>
                </v-col>
            </v-row>

            <v-row justify="center" class="mt-4">
                <v-col cols="12" sm="6" class="pt-0 pb-5" order-sm="last">
                    <v-btn block x-large
                        type="submit"
                        :color="tenantColor"
                        class="white--text"
                        @click="getVerificationCode()"
                        :disabled="buttondisabled1"
                        style="text-transform: none; color: #EBEBEB; font-size: 18px"
                    >
                        {{ print('PARTNER.VOYO.SSO_WEB.SEND_CODE_BTN') }}
                    </v-btn>
                </v-col>
                <v-col cols="12" sm="6" class="pt-0 pb-5" order-sm="first">
                    <v-btn block x-large color="secondary" @click="goBack"
                        style="text-transform: none; color: #EBEBEB; font-size: 18px"
                    >
                        {{ print('PARTNER.VOYO.SSO_WEB.CANCEL') }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-col>
    </v-row>



    <v-row class="text-center" justify="center" v-if="client_id && state == 'codesent'">
      <v-col cols="12" style="max-width: 500px;">
        <div class="d-none d-sm-flex" style="height:64px;"></div>

        <v-row class="text-center" justify="center">
            <v-col cols="12" sm="12">
                <p class="mb-1 heading1 text-center">{{ print('PARTNER.VOYO.SSO_WEB.FORGOT_PASSWORD') }}</p>
                <p class="mb-3 mt-3 heading1 text-center" style="border-bottom: 1px solid rgb(255,255,255,0.3); font-size:1px;">&nbsp;</p>
                <p class="mb-1 heading2 text-center">{{ print('PARTNER.VOYO.SSO_WEB.FORGOTTEN_PASSWORD_INFO') }}</p>
            </v-col>
        </v-row>
        <v-row justify="center" v-if="error !== ''">
            <v-col cols="12" sm="12">
                <p class="heading2 mb-0 mt-0" style="background-color: #FF00024D; color: white; border-radius: 5px; margin-top: 20px; padding: 15px 15px 15px 15px;">{{error}}</p>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="12" sm="6" class="pt-0 pb-5" order-sm="last">
                <v-btn block x-large
                    type="submit"
                    :color="tenantColor"
                    class="white--text"
                    @click="state = 'entercode'"
                    style="text-transform: none; color: #EBEBEB; font-size: 18px"
                >
                    {{ print('COMMON.OK') }}
                </v-btn>
            </v-col>
            <v-col cols="12" sm="6" class="pt-0 pb-5" order-sm="first">
                <v-btn block x-large color="secondary" @click="goBack"
                    style="text-transform: none; color: #EBEBEB; font-size: 18px"
                >
                    {{ print('PARTNER.VOYO.SSO_WEB.CANCEL') }}
                </v-btn>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="12" sm="12">
                <p class="mt-3 links"><a @click="state = 'gethelp'">{{ print('PARTNER.VOYO.SSO_WEB.NO_CODE_HELP') }}</a></p>
            </v-col>
        </v-row>
      </v-col>
    </v-row>



    <v-row class="text-center" justify="center" v-if="client_id && state == 'entercode'">
      <v-col cols="12" style="max-width: 500px;">
        <div class="d-none d-sm-flex" style="height:64px;"></div>

        <v-row class="text-center" justify="center">
            <v-col cols="12" sm="12">
                <p class="mb-1 heading1 text-center">{{ print('PARTNER.VOYO.SSO_WEB.VERIFICATION_CODE_TITLE') }}</p>
                <p class="mb-3 mt-3 heading1 text-center" style="border-bottom: 1px solid rgb(255,255,255,0.3); font-size:1px;">&nbsp;</p>
                <p class="mb-1 heading2 text-center">{{ print('PARTNER.VOYO.SSO_WEB.VERIFICATION_CODE_TEXT') }}</p>
            </v-col>
        </v-row>
        <v-row justify="center" v-if="error !== ''">
            <v-col cols="12" sm="12">
                <p class="heading2 mb-0 mt-0" style="background-color: #FF00024D; color: white; border-radius: 5px; margin-top: 20px; padding: 15px 15px 15px 15px;">{{error}}</p>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="12" sm="12">
                <v-text-field clearable outlined :placeholder="print('PARTNER.VOYO.SSO_WEB.VERIFICATION_CODE_TITLE')" hide-details="auto" v-model="verification_code" light background-color="white" color="#6C6C6C"
                autocapitalize="off"></v-text-field>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="12" sm="6" class="pt-0 pb-5" order-sm="last">
                <v-btn block x-large
                    type="submit"
                    :color="tenantColor"
                    class="white--text"
                    @click="sendVerificationCode()"
                    style="text-transform: none; color: #EBEBEB; font-size: 18px"
                >
                    {{ print('PARTNER.VOYO.SSO_WEB.CONFIRM_BTN') }}
                </v-btn>
            </v-col>
            <v-col cols="12" sm="6" class="pt-0 pb-5" order-sm="first">
                <v-btn block x-large color="secondary" @click="goBack"
                    style="text-transform: none; color: #EBEBEB; font-size: 18px"
                >
                    {{ print('PARTNER.VOYO.SSO_WEB.CANCEL') }}
                </v-btn>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="12" sm="12">
                <p class="mt-3 links"><a @click="state = 'gethelp'">{{ print('PARTNER.VOYO.SSO_WEB.NO_CODE_HELP') }}</a></p>
            </v-col>
        </v-row>
      </v-col>
    </v-row>



    <v-row class="text-center" justify="center" v-if="client_id && state == 'gethelp'">
      <v-col cols="12" style="max-width: 500px;">
        <div class="d-none d-sm-flex" style="height:64px;"></div>

        <v-row class="text-center" justify="center">
            <v-col cols="12" sm="12">
                <p class="mb-1 heading1 text-center">{{ print('PARTNER.VOYO.SSO_WEB.NO_CODE_GET_HELP_TITLE') }}</p>
                <p class="mb-3 mt-3 heading1 text-center" style="border-bottom: 1px solid rgb(255,255,255,0.3); font-size:1px;">&nbsp;</p>
                <p class="mb-1 heading2 text-center">{{ print('PARTNER.VOYO.SSO_WEB.NO_CODE_GET_HELP_TEXT') }}</p>
            </v-col>
        </v-row>
        <v-row justify="center" v-if="error !== ''">
            <v-col cols="12" sm="12">
                <p class="heading2 mb-0 mt-0" style="background-color: #FF00024D; color: white; border-radius: 5px; margin-top: 20px; padding: 15px 15px 15px 15px;">{{error}}</p>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="12" sm="6" class="pt-0 pb-5" order-sm="last">
                <v-btn block x-large
                    type="submit"
                    :color="tenantColor"
                    class="white--text"
                    @click="getVerificationCode()"
                    style="text-transform: none; color: #EBEBEB; font-size: 18px"
                >
                    {{ print('PARTNER.VOYO.SSO_WEB.SEND_AGAIN_BTN') }}
                </v-btn>
            </v-col>
            <v-col cols="12" sm="6" class="pt-0 pb-5" order-sm="first">
                <v-btn block x-large color="secondary" @click="goBack"
                    style="text-transform: none; color: #EBEBEB; font-size: 18px"
                >
                    {{ print('PARTNER.VOYO.SSO_WEB.CANCEL') }}
                </v-btn>
            </v-col>
        </v-row>
      </v-col>
    </v-row>



    <v-row class="text-center" justify="center" v-if="client_id && state == 'enterpass'">
      <v-col cols="12" style="max-width: 500px;">
        <div class="d-none d-sm-flex" style="height:64px;"></div>

        <v-row class="text-center" justify="center">
            <v-col cols="12" sm="12">
                <p class="mb-1 heading1 text-center">{{ print('PARTNER.VOYO.SSO_WEB.SET_NEW_PASSWORD_TITLE') }}</p>
                <p class="mb-3 mt-3 heading1 text-center" style="border-bottom: 1px solid rgb(255,255,255,0.3); font-size:1px;">&nbsp;</p>
                <p class="mb-1 heading2 text-center">{{ print('PARTNER.VOYO.SSO_WEB.SET_NEW_PASSWORD_TEXT') }}</p>
            </v-col>
        </v-row>
        <v-row justify="center" v-if="error !== ''">
            <v-col cols="12" sm="12">
                <p class="heading2 mb-0 mt-0" style="background-color: #FF00024D; color: white; border-radius: 5px; margin-top: 20px; padding: 15px 15px 15px 15px;">{{error}}</p>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="12" sm="12" class="pt-0 pb-5">
                <v-text-field clearable outlined :placeholder="print('PARTNER.VOYO.SSO_WEB.PASSWORD')" hide-details="auto" v-model="newpass1" light background-color="white" color="#6C6C6C"
                  :append-icon="showpassword ? 'mdi-eye' : 'mdi-eye-off'" :type="showpassword ? 'text' : 'password'" @click:append="showpassword = !showpassword"
                  autocapitalize="off"></v-text-field>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="12" sm="12" class="pt-0 pb-5">
                <v-text-field clearable outlined :placeholder="print('PARTNER.VOYO.SSO_WEB.PASSWORD_AGAIN')" hide-details="auto" v-model="newpass2" light background-color="white" color="#6C6C6C"
                  :append-icon="showpassword ? 'mdi-eye' : 'mdi-eye-off'" :type="showpassword ? 'text' : 'password'" @click:append="showpassword = !showpassword"
                  autocapitalize="off"></v-text-field>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="12" sm="12" class="pt-0 pb-5">
                <p class="mb-1 heading2 text-center">{{ print('PARTNER.VOYO.SSO_WEB.SET_NEW_PASSWORD_INFO') }}</p>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="12" sm="6" class="pt-0 pb-5" order-sm="last">
                <v-btn block x-large
                    type="submit"
                    :color="tenantColor"
                    class="white--text"
                    @click="sendNewPassword()"
                    :disabled="buttondisabled2"
                    style="text-transform: none; color: #EBEBEB; font-size: 18px"
                >
                    {{ print('PARTNER.VOYO.SSO_WEB.SAVE_BTN') }}
                </v-btn>
            </v-col>
            <v-col cols="12" sm="6" class="pt-0 pb-5" order-sm="first">
                <v-btn block x-large color="secondary" @click="goBack"
                    style="text-transform: none; color: #EBEBEB; font-size: 18px"
                >
                    {{ print('PARTNER.VOYO.SSO_WEB.CANCEL') }}
                </v-btn>
            </v-col>
        </v-row>
      </v-col>
    </v-row>


    <v-row class="text-center" justify="center" v-if="client_id && state == 'success'">
      <v-col cols="12" style="max-width: 500px;">
        <div class="d-none d-sm-flex" style="height:64px;"></div>

        <v-row class="text-center" justify="center">
            <v-col cols="12" sm="12" align="center">
                <v-img
                  class="shrink mr-2"
                  contain
                  :src="require('@/assets/available-2x.png')"
                  transition="scale-transition"
                  width="64"
                  style="filter: invert(0%);"
                />
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="12" sm="12">
                <p class="mb-1 heading1 text-center">{{ print('PARTNER.VOYO.SSO_WEB.PASWORD_SUCESS_INFO') }}</p>
            </v-col>
        </v-row>
        <v-row justify="center" v-if="error !== ''">
            <v-col cols="12" sm="12">
                <p class="heading2 mb-0 mt-0" style="background-color: #FF00024D; color: white; border-radius: 5px; margin-top: 20px; padding: 15px 15px 15px 15px;">{{error}}</p>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="12" sm="6" class="pt-0 pb-5">
                <v-btn block x-large
                    type="submit"
                    :color="tenantColor"
                    class="white--text"
                    @click="$router.push({ path: loginPath })"
                    style="text-transform: none; color: #EBEBEB; font-size: 18px"
                >
                    {{ print('PARTNER.VOYO.SSO_WEB.CONTINUE_BTN') }}
                </v-btn>
            </v-col>
        </v-row>
      </v-col>
    </v-row>

  </v-container>
</template>

<style>
    .heading1 {
        text-align: left;
        font-size: 30px;
        line-height: 1.2;
    }
    .heading2 {
        text-align: left;
        font-size: 18px;
        line-height: 1.2;
        letter-spacing: 0.7px;
    }
    
    .links a {
      color: #00A0DE;
      font-size: 18px
    }
    
    .links a.router-link-exact-active {
      color: #00A0DE;
    }
    
    .links a:link, a:visited {
      color: #00A0DE;
      text-decoration: none;
    }
    
    .links a:hover, a:active {
      color: #00A0DE;
      text-decoration: none;
    }
    
    .v-text-field {
        font-size: 1.5em;
        font-weight: 100;
    }
    
    .v-btn {
        text-transform: none;
        color: #EBEBEB;
        font-size: 1.5em !important;
        letter-spacing: normal;
    }
    
    </style>

<script>
  import { api } from "../main";
  import VueCookies from 'vue-cookies'
  //import HeaderComponent from '../components/HeaderComponent.vue'
  //import MY_CONFIG from "@/assets/config.json";

  export default {
    name: 'LogIn',

    components: {
        //HeaderComponent
    },

    data: () => ({
        state: 'enterusername',
        language: 'SK',
        languageoptions: ['SK','EN'
            /*{name: "SK"},
            {name: "CZ"},
            {name: "EN"}*/
        ],
        username: '',
        newpass1: '',
        newpass2: '',
        showpassword: false,
        error: '',
        client_id: '',
        redirect_uri: '',
        flow: '',
        tenant: '',
        verification_code: '',
        lang: {
            'button_reset': {'SK': 'Zaslať overovací kód', 'CZ': 'Send verification code', 'EN': 'Send verification code'},
            'header_resetpass_enterusername': {'SK': 'Resetovať zabudnuté heslo', 'CZ': 'Reset forgot passoword', 'EN': 'Reset forgot passoword'},
            'header_resetpass_codesent': {'SK': 'Zabudnuté heslo', 'CZ': 'Zabudnuté heslo', 'EN': 'Zabudnuté heslo'},
            'header_resetpass_entercode': {'SK': 'Zadajte verifikačný kód', 'CZ': 'Enter verification code', 'EN': 'Enter verification code'},
            'header_resetpass_gethelp': {'SK': 'Získať pomoc', 'CZ': 'Get help', 'EN': 'Get help'},
            'header_resetpass_enterpass': {'SK': 'Vytvorte si nové heslo', 'CZ': 'Set new password', 'EN': 'Set new password'},
            'header_resetpass_success': {'SK': 'Heslo bolo úspešne vytvorené', 'CZ': 'Password successfully created', 'EN': 'Password successfully created'},
        },
        buttondisabled1: false,
        buttondisabled2: false,
        buttondisabled3: false
    }),

    props: ['languagestrings', 'toperror'],

    computed: {
        queryParams() {
            var queryparamsarr = [];
            for (const [key, value] of Object.entries(this.$route.query)) {
                queryparamsarr.push(key + '=' + value);
            }
            return '?' + queryparamsarr.join('&');
        },
        tenantColor() {
            return this.tenant == 'DIGI' ? '#0095DA' : '#EA0A8E'; // '#0095DA'
        },
        loginPath() {
            return VueCookies.get('loginPath');
        }

    },

    methods: {

        goBack() {
            this.$router.go(-1)
        },

        print(input_prop) {
            return api.print(this.languagestrings, input_prop);
        },

        async getVerificationCode() {
            this.buttondisabled1 = true;
            // VALIDATE INPUT
            if(!this.client_id) {
                this.error = "ERROR: missing client_id";
                this.buttondisabled1 = false;
                return;
            }
            if(!this.username) {
                this.error = "Zadajte prosím prihlasovacie meno a heslo.";
                this.buttondisabled1 = false;
                return;
            }
            // CREATE POST DATA
            const data = {
                "loginOrNickname": this.username,
                "client_id": this.client_id,
                "language": this.language
            }
            // HTTP REQUEST
            const options = {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
              },
              body: new URLSearchParams(data)
            };
            var res = await api.requestData(api.baseUrl[this.tenant] + '/oauth/internal/reset-password-requests', options);
            
            // REQUEST RESULTS ACTIONS
            if(res.status == 'ok') {
                //console.log('reset-password-request response body', res.responseBody);
                this.state = 'codesent';
                this.error = '';
            }
            else {
                if(res.responseStatus == 'ECONNRESET') {
                    this.error = 'Pripojenie na server zlyhalo.';
                }
                else {
                    this.error = res.responseBody.error_description;
                }              
            }
            this.buttondisabled1 = false;
        },

        async sendVerificationCode() {
          this.state = 'enterpass';
        },

        async sendNewPassword() {
            this.buttondisabled2 = true;
            // VALIDATE INPUT
            if(!this.client_id) {
                this.error = "ERROR: missing client_id";
                this.buttondisabled2 = false;
                return;
            }
            if(!this.username) {
                this.error = "Zadajte prosím prihlasovacie meno.";
                this.buttondisabled2 = false;
                return;
            }
            if(!this.newpass1) {
                this.error = "Zadajte prosím nové heslo.";
                this.buttondisabled2 = false;
                return;
            }
            if(!this.newpass2) {
                this.error = "Zadajte prosím nové heslo druhý krát.";
                this.buttondisabled2 = false;
                return;
            }
            if(this.newpass1 != this.newpass2) {
                this.error = "Heslá nie su rovnaké.";
                this.buttondisabled2 = false;
                return;
            }

            // CREATE POST DATA
            const data = {
                "loginOrNickname": this.username,
                "password": this.newpass1,
                "code": this.verification_code,
                "client_id": this.client_id,
                "language": this.language
            }
            // HTTP REQUEST
            const options = {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
              },
              body: new URLSearchParams(data)
            };
            var res = await api.requestData(api.baseUrl[this.tenant] + '/oauth/internal/reset-password', options);
            
            // REQUEST RESULTS ACTIONS
            if(res.status == 'ok') {
                //console.log('reset-password response body', res.responseBody);
                this.state = 'success';
                this.error = '';
            }
            else {
                if(res.responseStatus == 'ECONNRESET') {
                    this.error = 'Pripojenie na server zlyhalo.';
                }
                else {
                    this.error = res.responseBody.error_description;
                }              
            }
            this.buttondisabled2 = false;
        },
        /*
        async logmein() {
            this.buttondisabled3 = true;
            // SAVE LANGUAGE TO COOKIES
            VueCookies.set('language' , this.language, "1h");

            // VALIDATE INPUT
            if(!this.client_id) {
                this.error = "ERROR: missing client_id";
                this.buttondisabled3 = false;
                return;
            }
            if(!this.flow) {
                this.error = "ERROR: missing flow";
                this.buttondisabled3 = false;
                return;
            }
            if(this.flow == 'AUTHORIZATION_CODE' && !this.redirect_uri) {
                this.error = "ERROR: missing redirect_uri";
                this.buttondisabled3 = false;
                return;
            }
            if(!this.username || !this.password) {
                this.error = "Zadajte prosím prihlasovacie meno a heslo.";
                this.buttondisabled3 = false;
                return;
            }

            // CREATE POST DATA
            const data = {
                "loginOrNickname": this.username,
                "password": this.password,
                "client_id": this.client_id,
                "language": this.language
            }

            // HTTP REQUEST
            const options = {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
              },
              body: new URLSearchParams(data)
            };
            var res = await api.requestData(api.baseUrl[this.tenant] + '/oauth/internal/login', options);
            
            // REQUEST RESULTS ACTIONS
            if(res.status == 'ok') {
                VueCookies.set('accessToken' , res.responseBody.accessToken, "1h");
                VueCookies.set('vopConsent' , res.responseBody.vopConsent, "1h");
                if(res.responseBody.vopConsent == true) {
                    this.$router.push({ path: '/allowpartner' });
                    //alert("VOP Consent je sice TRUE, ale aj tak otvorim consent, aby ste videli ako consenty vyzeraju. :)");
                    //this.$router.push({ path: '/consents' });
                }
                else {
                    this.$router.push({ path: '/consents' });
                }
            }
            else {
                if(res.responseStatus == 'ECONNRESET') {
                    this.error = 'Pripojenie na server zlyhalo.';
                }
                else {
                    this.error = res.responseBody.error_description;
                }
            }
            this.buttondisabled3 = false;
        }
        */
    },

    created: async function(){
        this.client_id = VueCookies.get('client_id');
        this.tenant = VueCookies.get('tenant');
        //this.language = VueCookies.get('language');
        //VueCookies.set('loginPath', this.$route.fullPath);
    }
  }
</script>
